if (!customElements.get('halle-promo-marquee')) {
  customElements.define('halle-promo-marquee', class extends HTMLElement {
    connectedCallback() {
      this.observer = new ResizeObserver(() => {
        const width = this.querySelector('.halle-promo-group').getBoundingClientRect().width;
        const speed = Math.max(20, Math.min(200, Number(this.dataset.speed) || 80));
        this.style.setProperty('--promo-duration', (width / speed) + 's');
      });
      this.observer.observe(this.querySelector('.halle-promo-group'));
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
